// extracted by mini-css-extract-plugin
export default {"badge_wrapper":"Badge_badge_wrapper__M1v1z","delete":"Badge_delete__d5JTb"};